import React, { useState, useEffect, useRef } from 'react';
import { getSortedNews } from '../data/news';

const News = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [newsItems, setNewsItems] = useState([]);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    setNewsItems(getSortedNews());
  }, []);

  const formatDate = (dateString) => {
    if (!dateString || dateString === 'Coming Soon') return 'Coming Soon';

    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}.${month}.${day}`;
  };

  const getCategoryIcon = (category) => {
    const icons = {
      'project': '🚀',
      'event': '🎉',
      'update': '📝',
      'other': '📰'
    };
    return icons[category] || '📰';
  };

  return (
    <section id='news' ref={sectionRef} className={`max-w-5xl mx-auto my-12 sm:my-16 px-4 sm:px-6 opacity-0 translate-y-8 transition-all duration-700 w-full ${isVisible ? 'opacity-100 translate-y-0' : ''}`}>
      <div className="mb-8 text-center sm:mb-12">
        <h1 className="mb-2 text-3xl font-bold text-transparent sm:text-4xl bg-gradient-to-r from-primary to-secondary bg-clip-text">News</h1>
        <div className="w-16 h-1 mx-auto rounded-full bg-gradient-to-r from-primary to-secondary"></div>
      </div>
      <div className="flex flex-col gap-6 sm:gap-8">
        {newsItems.length === 0 ? (
          <div className="p-8 text-center shadow-lg bg-white/5 backdrop-blur-sm rounded-2xl">
            <p className="text-lg text-gray-600">📰 ニュースは準備中です...</p>
          </div>
        ) : (
          newsItems.map((newsItem, index) => (
            <div
              key={newsItem.id}
              className="grid grid-cols-1 sm:grid-cols-[180px_1fr] gap-4 p-4 sm:p-6 bg-white/5 backdrop-blur-sm rounded-2xl shadow-lg border-l-4 border-primary hover:border-secondary transition-all duration-300 hover:translate-x-2 hover:shadow-xl"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="flex flex-col gap-2">
                <div className="px-3 py-2 text-sm font-semibold text-center rounded-lg text-primary bg-primary/10">
                  {formatDate(newsItem.date)}
                </div>
                <div className="flex items-center gap-2 px-3 py-1 text-xs font-medium text-gray-700 bg-gray-100 border border-gray-200 rounded-lg">
                  <span>{getCategoryIcon(newsItem.category)}</span>
                  <span>{newsItem.category}</span>
                </div>
              </div>
              <div className="space-y-3">
                <h3 className="text-lg font-bold text-gray-900 sm:text-xl">{newsItem.title}</h3>
                <p className="text-sm leading-relaxed text-gray-600 sm:text-base">{newsItem.content}</p>
                {newsItem.link && newsItem.link !== '#' && (
                  <a href={newsItem.link} className="inline-flex items-center gap-2 font-semibold transition-all duration-300 text-primary hover:text-secondary hover:gap-4">
                    go project <span className="transition-transform duration-300 hover:translate-x-1">→</span>
                  </a>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </section>
  );
};

export default News;
